"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _SelectOffersAccordionBoxContent = _interopRequireDefault(require("./SelectOffersAccordionBoxContent"));

var _SelectOffersAccordionBoxHeader = _interopRequireDefault(require("./SelectOffersAccordionBoxHeader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SelectOffersAccordionBox = function SelectOffersAccordionBox(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var elements = _react.default.Children.toArray(children);
  /**
   * To stop the AccordionBox from opening and closing on the click of a
   * child element, add a e.stopPropagation() to the onClick of the child
   * element.
   */


  var toggleOpenClose = function toggleOpenClose(e) {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  return /*#__PURE__*/_react.default.createElement(StyledAccordionBox, null, elements.map(function (element) {
    return /*#__PURE__*/_react.default.cloneElement(element, {
      open: isOpen,
      toggle: toggleOpenClose
    });
  }));
};

var StyledAccordionBox = _styledComponents.default.div.withConfig({
  displayName: "StyledAccordionBox"
})(["width:100%;max-width:120rem;background-color:white;border-radius:12px;border:1px solid #e4e4e4;box-shadow:0 0 1px rgba(0,0,0,0.04),0 2px 6px rgba(0,0,0,0.04),0 10px 20px rgba(0,0,0,0.04);transition:box-shadow 0.15s ease-in-out;&:hover{box-shadow:0 0 1px rgba(0,0,0,0.04),0 2px 6px rgba(0,0,0,0.04),0 16px 24px rgba(0,0,0,0.06);}"]);

SelectOffersAccordionBox.propTypes = {
  children: _propTypes.node
};
SelectOffersAccordionBox.Header = _SelectOffersAccordionBoxHeader.default;
SelectOffersAccordionBox.Header.displayName = 'SelectOffersAccordionBox.Header';
SelectOffersAccordionBox.Content = _SelectOffersAccordionBoxContent.default;
SelectOffersAccordionBox.Content.displayName = 'SelectOffersAccordionBox.Content';
var _default = SelectOffersAccordionBox;
exports.default = _default;